import API from "../API";

export default class SystemSetting extends API {
  constructor() {
    super('system-setting')
  }
 
}
